import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withStateHandlers } from 'recompose'
import * as AssistantSettingsActions from 'app/modules/assistantSettings/actions'
import { assistantAgentSettings, editingAssistantAgentSettings } from 'app/modules/assistantSettings/selectors'
import MeetingTaskConfig from './component'

const mapStateToProps = (state) => ({
  assistantAgentSettings: assistantAgentSettings(state),
  editingAssistantAgentSettings: editingAssistantAgentSettings(state)
})


const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      patchAssistantAgentSettings: AssistantSettingsActions.patchAssistantAgentSettings,
      setInitial: AssistantSettingsActions.setInitial,
      onUpdate: AssistantSettingsActions.onUpdate,
      onCancel: AssistantSettingsActions.onCancel,
      onWarmLeadUpdate: AssistantSettingsActions.onWarmLeadUpdate,
      onWarmLeadUpdateTemplate: AssistantSettingsActions.onWarmLeadUpdateTemplate,
    },
    dispatch
  ),
})


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    () => ({ 
      modalOpen: false,
    }),
    {
      toggleModal: ({ modalOpen }) => () => ({ modalOpen: !modalOpen }),
    }
  ),
  withHandlers({
    onSave: ({ actions, editingAssistantAgentSettings }) => () => {
      return actions.patchAssistantAgentSettings({ settings: editingAssistantAgentSettings })
    },
    onCancel: ({ actions, assistantAgentSettings }) => () => {
      return actions.onCancel(assistantAgentSettings)
    }
  })
)(MeetingTaskConfig)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/AssistantConfig/MeetingTaskConfig/index.js